import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=259b6306"
import script from "./Reporting.vue?vue&type=script&lang=ts"
export * from "./Reporting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports